export const OnboardingRedirect = (res, history) => {
  const intended = history.location.state;
  if (intended) {
    history.push(intended.from);
  } else {
    if (!res.data.user) {
      window.location.href = "/";
    } else if (res.data.user.role === "superadmin") {
      window.location.href = "/super-admin/dashboard";
    } else if (res.data.user.role === "marketing") {
      history.push("/marketing-admin/dashboard");
    } else if (res.data.user.role === "admin") {
      // Always go to dashboard - modals will handle onboarding/subscription
      window.location.href = `/a/ws/${res.data.user.workspaceId}/dashboard`;
    }
  }
};

export const RoleBasedRedirect = (res, history) => {
  const intended = history.location.state;
  if (intended) {
    history.push(intended.from);
  } else {
    if (!res.data.user) {
      history.push("/");
    } else if (res.data.user.role === "superadmin") {
      history.push("/super-admin/dashboard");
    } else if (res.data.user.role === "marketing") {
      history.push("/marketing-admin/dashboard");
    } else if (res.data.user.role === "admin") {
      // Always go to dashboard - modals will handle onboarding/subscription
      history.push(`/a/ws/${res.data.user.workspaceId}/dashboard`);
    }
  }
};

export const RoleBasedRedirectWithUser = (user, history) => {
  const intended = history.location.state;
  if (intended) {
    history.push(intended.from);
  } else {
    if (!user) {
      history.push("/");
    } else if (user.role === "superadmin") {
      history.push("/super-admin/dashboard");
    } else if (user.role === "marketing") {
      history.push("/marketing-admin/dashboard");
    } else if (user.role === "admin") {
      // Always go to dashboard - modals will handle onboarding/subscription
      history.push(`/a/ws/${user.workspaceId}/dashboard`);
    }
  }
};

export const redirectToDashboard = (user) => {
  if (user?.role === "superadmin") {
    return "/super-admin/dashboard";
  } else if (user?.role === "marketing") {
    return "/marketing-admin/dashboard";
  } else if (user?.role === "admin") {
    // Always go to dashboard - modals will handle onboarding/subscription
    return `/a/ws/${user.workspaceId}/dashboard`;
  }
};

export const RedirectOnLogout = () => {
  window.location.href = `/login`;
};
